<template>
    <div class="my-2">
        <v-row :key="lizenz.SerialID" class="blue lighten-5 ma-1 elevation-1" v-for="lizenz in lizenzen">
            <v-col cols="2">

                <div class="font-weight-bold grey--text">SerialNumber</div>
                <div :data-id="lizenz.SerialNum"
                     @click="copyValueToClipboard" @mouseleave="hoover = false" @mouseover="hoover = true">{{
                    lizenz.SerialNum }} <span :data-id="lizenz.SerialNum" @click="copyValueToClipboard"
                                              style="color: #0069ff;"
                                              v-show="hoover">{{copyText}}</span></div>

            </v-col>
            <v-col>
                <div class="font-weight-bold grey--text">Gültig von</div>
                <save-date-picker :licence-i-d="lizenz.SerialNum" :toast="toast" type="von"
                                  v-model="lizenz.GueltigVon"></save-date-picker>
            </v-col>
            <v-col>
                <div class="font-weight-bold grey--text">Gültig bis</div>
                <save-date-picker :licence-i-d="lizenz.SerialNum" :toast="toast" type="bis"
                                  v-model="lizenz.GueltigBis"></save-date-picker>
            </v-col>
            <v-col>
                <div class="font-weight-bold grey--text">Policy</div>
                <div>{{ lizenz.Policy }}</div>
            </v-col>
            <v-col>
                <div class="font-weight-bold grey--text">Status</div>
                <div>{{ lizenz.Status }}</div>
            </v-col>
            <v-col>
                <div class="font-weight-bold grey--text">Kommentar</div>
                <div>{{ lizenz.Kommentar }}</div>
            </v-col>
            <v-col>
                <div class="font-weight-bold grey--text">UpdateStatus</div>
                <div>{{ lizenz.UpdateStatus }}</div>
            </v-col>

            <v-col>

                <v-tooltip left>
                    <template v-slot:activator="{ on }">
                        <v-badge

                                :value="!isDisabled(lizenz.Status)"
                                bordered
                                color="red"
                                icon="fas fa-lock"
                                overlap
                        >
                            <v-btn :disabled="isDisabled(lizenz.Status)" @click="sperrenClick(lizenz.SerialNum)" class="ma-1" color="red lighten-2"
                                   rounded small
                                   v-on="on" width="100"> Sperren
                            </v-btn>
                        </v-badge>

                    </template>
                    <span>Sperren</span>
                </v-tooltip>
                <v-tooltip left>
                    <template v-slot:activator="{ on }">
                        <v-badge
                                :value="!isDisabled(lizenz.Status)"
                                bordered
                                color="blue"
                                icon="fas fa-reply-all"
                                overlap
                        >
                            <v-btn :disabled="isDisabled(lizenz.Status)" @click="ersetzenClick(lizenz.SerialNum)" class="ma-1" color="blue lighten-2"
                                   rounded small
                                   v-on="on" width="100"> Ersetzen
                            </v-btn>
                        </v-badge>
                    </template>
                    <span>Ersetzen</span>
                </v-tooltip>
            </v-col>

        </v-row>
        <lizenz-ersetzen :licence-id="selectedId" :show-popup="showErsetzen" v-if="showErsetzen.show"></lizenz-ersetzen>
        <lizenz-sperren :licence-id="selectedId" :show-popup="showSperren" v-if="showSperren.show"></lizenz-sperren>
        <v-snackbar
                :timeout=2000
                multi-line
                top
                v-model="toast.show">
            <div>Erfolgreich gespeichert</div>
        </v-snackbar>
    </div>
</template>

<script>
    import LizenzErsetzen from "./LizenzErsetzen";
    import LizenzSperren from "./LizenzSperren";
    import SaveDatePicker from "./SaveDatePicker";


    const copyToClipboard = str => {
        const el = document.createElement('textarea');
        el.value = str;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    };
    export default {


        components: {SaveDatePicker, LizenzErsetzen, LizenzSperren},

        methods: {
            isDisabled(status) {
                if (status === 'Deaktiviert')
                    return true;
                return false;
            },

            sperrenClick(id) {
                this.selectedId = id;
                this.showSperren.show = true

            },
            ersetzenClick(id) {
                this.selectedId = id;
                this.showErsetzen.show = true;
            },

            copyValueToClipboard(element) {
                let id = element.target.getAttribute("data-id");
                this.copyText = "Copied: " + id;
                setTimeout(() => {
                    this.copyText = "Copy"
                }, 1000);
                copyToClipboard(id);
            },

        },
        props: {
            lizenzen: Array
        },
        data() {
            return {
                toast: {
                    show: false
                },
                selectedId: null,
                showErsetzen: {
                    show: false
                },
                showSperren: {
                    show: false
                },
                hoover: false,
                copyText: "Copy"
            }
        },
    }
</script>
<style>


</style>
